import { render, staticRenderFns } from "./DefaultSort.vue?vue&type=template&id=1536baad"
import script from "./DefaultSort.vue?vue&type=script&lang=js"
export * from "./DefaultSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports